<template>
  <div>
    <h3>Expense Table Component Example</h3>
    
    <!-- Use the expense table component -->
    <expense-table-component
      :show-debug="false"
      @expenses-saved="handleExpensesSaved"
    />
    
    <!-- Display saved expenses summary -->
    <div v-if="savedExpensesHistory.length > 0" class="mt-4">
      <h4>Saved Expenses History:</h4>
      <div v-for="(batch, batchIndex) in savedExpensesHistory" :key="batchIndex" class="mb-4">
        <b-card>
          <h6>Batch {{ batchIndex + 1 }} - {{ batch.timestamp }}</h6>
          <div class="row">
            <div v-for="(expense, index) in batch.expenses" :key="index" class="col-md-6 mb-2">
              <b-card variant="light" class="h-100">
                <small>
                  <strong>{{ getExpenseText(expense.natureOfExpense) }}</strong><br/>
                  Incurred: {{ expense.expenseIncurred }}<br/>
                  <span v-if="expense.expenseIncurred === 'Yes'">
                    Amount to Pay: ${{ expense.amountToBePaid }}<br/>
                  </span>
                  Bill to Shipper: {{ expense.billToShipper }}<br/>
                  <span v-if="expense.billToShipper === 'Yes'">
                    Amount to Bill: ${{ expense.amountToBeBilled }} ({{ getBillToText(expense.billToType) }})<br/>
                  </span>
                </small>
              </b-card>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import ExpenseTableComponent from "./expenseTableComponent.vue";

export default {
  name: "ExpenseTableExample",
  components: {
    ExpenseTableComponent,
  },
  data() {
    return {
      savedExpensesHistory: [],
      billToOptions: [
        { text: "Bill to Shipper", value: "shipper" },
        { text: "Bill to Agent", value: "agent" },
      ],
    };
  },
  methods: {
    handleExpensesSaved(expensesData) {
      // Handle the saved expenses data
      const batch = {
        expenses: expensesData,
        timestamp: new Date().toLocaleString(),
        id: Date.now(),
      };
      this.savedExpensesHistory.unshift(batch);
      console.log("Received expenses data:", expensesData);
    },
    getExpenseText(value) {
      // This would normally come from the same API data
      return value || "Unknown Expense";
    },
    getBillToText(value) {
      const option = this.billToOptions.find(opt => opt.value === value);
      return option ? option.text : value;
    },
  },
};
</script>

<style scoped>
.mt-4 {
  margin-top: 1.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.h-100 {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// expenseTableExample.vue?1390e1a3